import type { FieldConfig } from '@app/src/pages/TabularImport/shared/fieldConfig'

export const PROVIDER_REQUIRED_FIELDS = ['Name', 'Country'] as const

// Order determines column order in the review table and compare view.
export const PROVIDER_FIELD_CONFIGS: FieldConfig[] = [
  { key: 'Name', label: 'Name', required: true, editType: 'text' },
  { key: 'Country', label: 'Country', required: true, editType: 'country' },
  { key: 'WebsiteAddress', label: 'Website', editType: 'text', truncate: true },
  { key: 'Industry', label: 'Industry', editType: 'industry' },
  { key: 'RegistrationNumber', label: 'Registration Number', editType: 'text' },
  { key: 'CustomId', label: 'Custom ID', editType: 'text' },
  { key: 'Duns', label: 'DUNS Number', editType: 'text' },
  { key: 'VatNumber', label: 'VAT Number', editType: 'text' },
  { key: 'ReferralContact', label: 'Referral Contact', editType: 'text' },
  { key: 'Owners', label: 'Owners', editType: 'text' },
  { key: 'Tier', label: 'Tier', editType: 'text' },
  { key: 'Priority', label: 'Priority', editType: 'text' },
  { key: 'RiskStatus', label: 'Risk Status', editType: 'text' },
  { key: 'ApprovalStatus', label: 'Approval Status', editType: 'text' },
  { key: 'SupplierUsage', label: 'Supplier Usage', editType: 'text' },
]
